const OpenLink = {
    init() {
        const link = document.querySelector('.configurator-actions__btn');
        if (link) {
            link.addEventListener('click', this.handleClick.bind(this));
        }
    },

    handleClick(event) {
        event.preventDefault();
        const url = event.target.href;
        const target = event.target.getAttribute('data-target');
        if (target === '_blank') {
            const newTab = window.open(url, '_blank');
            newTab.focus();
        } else if (target === '_new') {
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer,width=800,height=600');
            newWindow.opener = null;
            newWindow.focus();
        } else {
            window.location.href = url;
        }
    }
};

export default OpenLink;
